<template>
    <div>
        <!--Header Components-->
        <base-header class="pb-6" type="">
          <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
              <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
              <h6 class="h2 d-inline-block mb-0">{{ language_terms["PURCHASE_RETURNS"]}}</h6>
              <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-breadcrumb/>
              </nav>
            </b-col>
          </b-row>
        </base-header>
        <b-container fluid class="mt--6">
          <div>
              <loading :active.sync="loading"
                color= '#007bff'
                :width= '128'
                :height= '128'
                loader='dots'
                :can-cancel="true"
                :is-full-page="fullPage">
              </loading>
          </div>
          <b-row>
            <b-col lg="12">
              <div class="card-wrapper">
                <card>
                  <div slot="header" class="mb-0">
                    <b-row>
                      <b-col cols="8">
                          <h3>{{language_terms['QUICK_SEARCH']}}</h3>
                      </b-col>
                      <b-col cols="4">
                         <base-button type="success" @click="addNew" class="float-right">
                            <i class="fa fa-plus"></i>
                          </base-button>
                      </b-col>
                    </b-row>
                  </div>
                  <b-row>
                    <b-col md="3" >
                      <base-input :label="language_terms['VENDORS']" v-model="filter.contact_name" v-on:keyup.enter="clickOnSearch()">
                      </base-input>
                    </b-col>
                    <b-col md="2" >
                      <base-input :label="language_terms['PRT_#']" v-model="filter.product_code" v-on:keyup.enter="clickOnSearch()">
                      </base-input>
                    </b-col>
                    <b-col md="2" >
                      <base-input :label="language_terms['DATE_FROM']">
                        <flat-picker slot-scope="{focus, blur}"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white;"
                                    class="form-control datepicker"
                                    v-model="filter.date_from">
                        </flat-picker>
                      </base-input>
                    </b-col>
                    <b-col md="2">
                      <base-input :label="language_terms['DATE_TO']">
                        <flat-picker slot-scope="{focus, blur}"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white;"
                                    class="form-control datepicker"
                                    v-model="filter.date_to">
                        </flat-picker>
                      </base-input>
                    </b-col>

                    <b-col md="2">
                      <base-input :label="language_terms['STATUS']">
                        <el-select v-model="filter.status" filterable>
                          <el-option v-for="option in status_options"
                                    :key="option.value"
                                    :label="option.label"
                                    :value="option.value">
                          </el-option>
                        </el-select>
                      </base-input>
                    </b-col>
                    <b-col cols="1" class="mt-4">
                      <base-button type="primary" @click="clickOnSearch" class="mt-2"><i class="fa fa-search"></i></base-button>
                    </b-col>
                  </b-row>
                </card>
                <!-- Search Results -->
                <!-- zehua -->
                <b-row v-if="filter.items.length > 0">
                <b-col lg="12">
                  <div class="card-wrapper">
                    <card>
                      <div slot="header" class="mb-0">
                        <b-row>
                          <b-col lg="11">
                              <h3>Search Results</h3>
                          </b-col>
                        </b-row>
                      </div>
                      <b-row class="mt--4">
                        <b-col cols="12" class="mt-3">
                          <b-table-simple hover responsive>
                              <b-thead head-variant="light">
                                  <b-th>{{language_terms['PRT_#']}}</b-th>
                                  <b-th>{{language_terms['VENDOR']}}</b-th>
                                  <b-th>{{language_terms['DATE']}}</b-th>
                                  <b-th>{{language_terms['ACTION_RECOMMENDED']}} </b-th>
                              </b-thead>
                              <b-tbody>
                                  <tr v-for="(item, i) in filter.items" :key="i" @click="onClickPRT(item)">
                                      <td>{{item.code}}</td>
                                      <td>{{item.contact_name}}</td>
                                      <td>{{item.date}}</td>
                                      <td>{{item.action_recommended}}</td>
                                  </tr>
                              </b-tbody>
                          </b-table-simple>
                        </b-col>
                      </b-row>
                    </card>
                  </div>
                </b-col>
              </b-row>
              </div>
            </b-col>
          </b-row>
        </b-container>
    </div>
  </template>
<script>
  import { Select, Option } from 'element-ui'
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { mapState } from "vuex";
  import PaginatedTables from '@/views/Tables/PaginatedTables'
  import axios from "axios";
  import { apiRoutes } from "../../apiRoutes";
  import { authHeader } from "../../global";
  import Vue from 'vue'

export default {
components:{
  Loading,
  [Select.name]: Select,
  [Option.name]: Option,
  flatPicker,
  PaginatedTables
},
computed:{
    ...mapState({
      language_terms: state => state.languages.language_terms,
      selected_lang: state => state.languages.selected_langauge,
    }),
  },
watch:{
    language_terms: {
        handler(val){
            this.updateTableLang()
        }
      },
},
async mounted()
{
  this.loading = true

  this.updateTableLang()

  this.loading = false

},

data(){
  return{
    fullPage:true,
    loading:false,
    filter:{
      contact_name: null,
      product_code:"",
      date_from:null,
      date_to:null,
      type:null,
      status:'ALL',
      items: [],
    },
    status_options:[
      {
        label:"All",
        value:"ALL"
      },
      {
        label:"Open",
        value:"OPEN"
      },
      {
        label:"Posted",
        value:"POSTED"
      },
      {
        label:"Approved",
        value:"APPROVED"
      },
      {
        label:"Cancelled",
        value:"CANCELLED"
      },
    ],
    /*sales_types:[
      {
        label:"Quotation",
        value:"SQ"
      },
      {
        label:"Order",
        value:"SO"
      },
      {
        label:"Invoice",
        value:"SI"
      }
    ]**/
  }
},

methods:{
  async onClickPRT(item)
  {
    if(item)
    {
      this.loadingCounter++
      let payload = {code:item.code}
      await axios
        .post(apiRoutes["PURCHASERETURN_RETRIEVE"], payload, authHeader())
      .then((response) =>
      {
        if (response.data.code == 1) {
          this.$router.push("/purchase/purchase-return/" + encodeURIComponent(item.code))
        }
        else
        {
          alert('Failed');
        }

      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
      });

      this.loadingCounter--
    }
  },
  updateTableLang(){
    // for(let i=0; i < this.do_tableColumns.length;i++)
    // {
    //   let key = this.do_tableColumns[i].key
    //   this.do_tableColumns[i].label = this.language_terms[key]
    // }

  },
  async clickOnSearch()
  {
    this.loading = true

    this.filter.limit = ''
    let payload = this.filter

    await axios
    .post(apiRoutes["PURCHASERETURN_QUICK_SEARCH"], payload, authHeader())
    .then((response) =>
    {
      if (response.data.code == 1) {
        // alert('Success' + response.data.data[0].code)
        this.filter.items = response.data.data
      }
      else
      {
        alert('Failed');
      }

    })
    .catch((error) => {
      if (error.response) {
        Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
      }
    });


    this.loading = false
  },
  clickOnReset(){
    this.filter = {
        keyword:"",
        date_from:null,
        date_to:null,
        //type:'SQ',
        status:'ALL'
    }
  },
  async addNew()
  {
    let url = '/purchase/purchase-return/_new'
    this.$router.push(url)
  }
}
}
  </script>
